import { LinkTabs } from "@dgs/core";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { StyledLinkTab } from "./CompanyPage";

export const CompanyDetailsNavigation = () => {
	const { t } = useTranslation();

	return (
		<div>
			<LinkTabs>
				<StyledLinkTab to="details">{t("Details")}</StyledLinkTab>
				<StyledLinkTab to="contacts">{t("Contacts")}</StyledLinkTab>
				<StyledLinkTab to="clippings">{t("Clippings")}</StyledLinkTab>
			</LinkTabs>
			<Outlet />
		</div>
	);
};
